export default __webpack_public_path__ + "img/cIiShrAD.91b3adca.svg";